import { IBeeConfig } from "@beefree.io/sdk/dist/types/bee";

import { Box } from "ui/box";
import Bee, {
  BEE_CONTAINER_ID,
} from "containers/admin/clients/touchpoint/components/bee-editor/bee/bee";
import { contentPadding } from "components/partials/layout/layout";

import { useCurrentClient } from "hooks/api/use-clients";

import { BeeConfig } from "types/bee";
import { TouchpointType } from "types/touchpoint";

/**
 * https://docs.beefree.io/tracking-message-changes/#callback-parameters */
export interface BeeChangeResponse {
  code: string;
  description: string;
  value: string;
  patches: Record<string, any>[];
}

interface BeeEditorProps extends Omit<IBeeConfig, "container"> {
  editorType: TouchpointType;
  initialJson?: string;
  themeConfig?: BeeConfig;
}

const BeeEditor = ({ editorType, initialJson, onChange, themeConfig }: BeeEditorProps) => {
  const client = useCurrentClient();

  const beeStyles = {
    height: `calc(100% + ${contentPadding.bottom})`,
    marginLeft: `-${contentPadding.left}`,
    width: `calc(100% + ${contentPadding.left} + ${contentPadding.right})`,
  };

  let parsedTemplate = undefined;
  if (initialJson) {
    try {
      parsedTemplate = JSON.parse(initialJson);
    } catch (error) {
      console.log(error);
    }
  }

  // Scoped to BEE's container so we don't strip the sandbox off the touchpoint-preview iframe.
  const attachSandboxAttributeToIframe = () => {
    document
      .getElementById(BEE_CONTAINER_ID)
      ?.querySelectorAll("iframe")
      .forEach((iframeNode) => iframeNode.setAttribute("sandbox", ""));
  };

  return (
    <Box id="bee-content-creator" sx={{ flex: "1" }}>
      <Bee
        isEmail={editorType === TouchpointType.EMAIL}
        style={beeStyles}
        onChange={onChange}
        onSend={(htmlFile: any) => console.log("--onSend--", htmlFile, "--/onSend--")}
        onSaveAsTemplate={(jsonFile: any) =>
          console.log("--onSaveAsTemplate--", jsonFile, "--/onSaveAsTemplate--")
        }
        onError={(errorMessage: any) => console.log(errorMessage)}
        beeConfig={
          {
            ...themeConfig,
            onLoad: attachSandboxAttributeToIframe,
          } as Omit<IBeeConfig, "container">
        }
        baseTemplate={parsedTemplate}
        clientId={client.id}
      />
    </Box>
  );
};

export default BeeEditor;
